<ng-container *ngFor="let item of listHelp">

  <li *ngIf="item.type === LIST_HELP_TYPE.HELP && articles.get(item.flag)"
      (click)="onSelectHelp($event, item)">
    <div class="help-item-box2 {{ articles.get(item.flag)?.thumbnail ? 'thumnail' : '' }}">
      <div class="img-box"
           *ngIf="articles.get(item.flag)?.thumbnail"> <!-- 썸네일 이미지가 없고, 선택되지 않은 경우 표시 -->
        <img src="{{ ApiUrl(articles.get(item.flag)?.thumbnail ?? '') }}" alt="이미지">
      </div>

      <div class="subject-box">
        <div [innerHTML]="articles.get(item.flag)?.title ?? null | resize | keepHtml"></div>
        <div class="close-btn"
             (click)="onClose(item, $event)">
        </div>
      </div>

      <div class="con-box"
           [innerHTML]="articles.get(item.flag)?.brief ?? null | resize | keepHtml">
      </div>
    </div>
  </li>

  <li *ngIf="item.type === LIST_HELP_TYPE.OPTION">
    <div class="item-box">
      <app-option-item class="item-option"
                       [optionItem]="GetOptionItem(item.content)"
                       [closeBtn]="true"
                       (close)="onClose(item)"></app-option-item>
      <div class="setting-box-more" [innerHTML]="(item.comment ?? '우右 상단의 \'설정\'에서도 변경을 할 수 있습니다.') | resize | keepHtml" ></div>
    </div>
  </li>
</ng-container>
